export default "__VITE_ASSET__N772xdaz__"